import CalDay from '@/components/UI/calendar/CalDay.vue'
import CalMonth from '@/components/UI/calendar/CalMonth.vue'
import SelectYear from '@/components/UI/calendar/SelectYear.vue'
import SelectMonth from '@/components/UI/calendar/SelectMonth.vue'
import ButtonAdd from '@/components/UI/ButtonAdd.vue'
import DateInput from '@/components/UI/DateInput.vue'
import DayHours from '@/components/UI/DayHours.vue'
import ModalResult from '@/components/UI/ModalResult.vue'
import MyPreloader from '@/components/UI/MyPreloader.vue'
import MyToggle from './MyToggle.vue'
import CookieBanner from './CookieBanner.vue'


export default[
    CalDay,
    CalMonth,
    SelectYear,
    SelectMonth,
    ButtonAdd,
    DateInput,
    DayHours,
    ModalResult,
    MyPreloader,
    MyToggle,
    CookieBanner
]

